import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersAiChatRoomsAiEmployeeConversationsIndexResponseType } from "~/domains";

type RequestDataType = {
  aiChatRoomId: string;
  page?: number;
};

const request = async ({
  aiChatRoomId,
  page = 1,
}: RequestDataType): Promise<ApiMembersAiChatRoomsAiEmployeeConversationsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersAiChatRoomsAiEmployeeConversationsIndexResponseType>(
      `/api/members/ai_chat_rooms/${aiChatRoomId}/ai_employee_conversations`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  aiChatRoomId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersAiChatRoomsAiEmployeeConversationsIndex = ({
  aiChatRoomId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersAiChatRoomsAiEmployeeConversationsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersAiChatRoomsAiEmployeeConversationsIndex", aiChatRoomId],
    ({ pageParam }) => {
      return request({ aiChatRoomId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
